import Stack from '@mui/material/Stack'
import { useLocation } from 'react-router'
import { HeaderLayout } from './header.layout'
import { FooterLayout } from './footer.layout'
import ReferralBar from '@/core/referral/ReferralBar'

const REFERRAL_PAGES = ['/', '/products', '/sign-up']

const MainLayout = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation()
    const showReferral = REFERRAL_PAGES.includes(location.pathname)

    return (
        <Stack width="100%" height="100%" data-testid="main-stack-header-layout">
            <HeaderLayout data-testid="main-header-layout" />
            {showReferral && <ReferralBar data-testid="main-referral-bar" />}
            <Stack width="100%" height="100%" sx={{ overflowX: 'hidden', boxSizing: 'border-box' }} data-testid="main-stack">
                {children}
            </Stack>
            <FooterLayout data-testid="main-footer-layout" />
        </Stack>
    )
}

export default MainLayout
